// src/App.jsx
import React, { useState } from 'react';
import LoginPage from './pages/LoginPage';
import ScannerPage from './pages/ScannerPage';

function App() {
  const [token, setToken] = useState(null);

  return (
    <div className="min-h-screen">
      {token ? (
        <ScannerPage token={token} />
      ) : (
        <LoginPage onLogin={setToken} />
      )}
    </div>
  );
}

export default App;
